import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useGetInboxCountsQuery } from '@/redux/internal-services/notificationsApi';
import { useAppDispatch, useAppSelector } from '@/hooks';
import { openNotificationsPanel, toggleNotificationsPanel } from '@/redux/slices/notificationsPanelSlice';

const NotificationBell: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const isPanelOpen = useAppSelector((state) => state.notificationsPanel.isOpen);
  const { data: counts } = useGetInboxCountsQuery();
  const unread = counts?.unread ?? 0;

  const handleClick = () => {
    if (location.pathname !== '/chat') {
      dispatch(openNotificationsPanel());
      navigate('/chat');
    } else {
      dispatch(toggleNotificationsPanel());
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-pressed={isPanelOpen}
      className="relative flex h-9 w-9 items-center justify-center rounded-lg focus:outline-none focus:ring-2 focus:ring-brand-dark/40 text-ui-text2 hover:bg-ui-hover"
      aria-label="Notifications"
    >
      <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
          d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
      </svg>
      {unread > 0 && (
        <span className="absolute -right-0.5 -top-0.5 flex h-4 w-4 items-center justify-center rounded-full bg-[#CF4148] text-[10px] font-bold leading-none text-white">
          {unread > 99 ? '99+' : unread}
        </span>
      )}
    </button>
  );
};

export default NotificationBell;
